var render = function render(_c,_vm){return _c('div',[_c('a',{class:[_vm.props.row.totalConsumption >= 0 ? 'Negro' : 'Rojo'],attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.show(_vm.props)}}},[_vm._v(_vm._s(_vm.$options.formatMonto(_vm.props.row.totalConsumption)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }